import { useAuth, useUser } from '@clerk/clerk-react';
import { AuthBridge } from '@/components/AuthBridge';
import { AuthScreen } from '@/components/auth/AuthScreen';
import { Dashboard } from '@/components/Dashboard';

export default function App() {
  const { isSignedIn, isLoaded, userId } = useAuth();
  // Pre-warm the user cache so Dashboard's `useUser()` returns immediately.
  void useUser();

  if (!isLoaded) {
    return (
      <div className="flex min-h-dvh items-center justify-center text-muted-foreground">
        <div className="text-sm">Loading…</div>
      </div>
    );
  }

  return (
    <>
      <AuthBridge />
      {isSignedIn && userId ? <Dashboard /> : <AuthScreen />}
    </>
  );
}
